<template>
  <div class="container-xl mt-4">
    <div class="row row-cards">
      <div class="col-md-3"></div>
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">更改密碼</h3>
          </div>
          <div class="card-body">
            <div
              :class="
                alertStatus === 'success'
                  ? 'alert alert-success'
                  : 'alert alert-danger'
              "
              v-show="alertStatus !== ''"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <form @submit.prevent="changePassword" ref="form">
              <div class="row mb-3 align-items-center">
                <div class="col-3">舊密碼</div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    name="example-disabled-input"
                    value=""
                    v-model="form.password"
                  />
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-3">新密碼</div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    name="example-disabled-input"
                    value=""
                    v-model="form.newPassword"
                  />
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-3">重複新密碼</div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    name="example-disabled-input"
                    value=""
                    v-model="form.repeatNewPassword"
                  />
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-6"></div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <router-link
                        to="myProfile"
                        class="btn btn-outline-secondary w-100"
                      >
                        返回
                      </router-link>
                    </div>
                    <div class="col-6">
                      <button
                        type="submit"
                        class="btn btn-outline-primary w-100"
                      >
                        更改
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      alertMsg: "",
      alertStatus: "",
      token: "",
      form: {
        password: "",
        newPassword: "",
        repeatNewPassword: "",
      },
    };
  },
  methods: {
    async changePassword() {
      if (this.form.newPassword !== this.form.repeatNewPassword) {
        this.alertStatus = "Error";
        this.alertMsg = "密碼不同";
      } else if (this.form.newPassword.length < 6) {
        this.alertStatus = "Error";
        this.alertMsg = "密碼需大於六個字元";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/changePassword`;
        const vm = this;
        try {
          const res = await this.$http.patch(api, vm.form, {
            headers: { Authorization: `Bearer ${this.token}` },
          });
          if (res.data.status !== "success") {
            throw "error";
          }
          this.alertStatus = "success";
          this.alertMsg = "修改成功";
          this.form.password = "";
          this.form.newPassword = "";
          this.form.repeatNewPassword = "";
        } catch (err) {
          if (err.response.status === 401) {
            this.$parent.$parent.isExpired = true;
            this.$parent.$parent.checkSessionExpired()
          }
          this.alertStatus = "Error";
          this.alertMsg = "錯誤";
        }
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
  },
};
</script>
